/** Suggested vocabularies for the program form. All pickers allow a custom value too. */

export const LEVELS = ['Beginner', 'Intermediate', 'Advanced', 'All levels'];

export const GOALS = [
  'Build muscle',
  'Lose fat',
  'Get lean',
  'Get stronger',
  'Build endurance',
  'Improve mobility',
  'General fitness',
];

export const TARGET_AREAS = [
  'Full body',
  'Upper body',
  'Lower body',
  'Core',
  'Chest',
  'Back',
  'Shoulders',
  'Arms',
  'Glutes',
  'Legs',
];

export const EQUIPMENT = [
  'No equipment',
  'Dumbbells',
  'Barbell',
  'Kettlebell',
  'Resistance bands',
  'Machine',
  'Cable',
  'Pull-up bar',
  'Bench',
];

export const DAYS_PER_WEEK = [1, 2, 3, 4, 5, 6, 7];
